<template>
  <div class="order-purchase-number">
    <v-text-field
      v-model="localValue.purchase.number.poNumber"
      placeholder="PO3454098"
      append-icon="mdi-receipt"
      outlined
    />
    <v-text-field
      v-model="localValue.purchase.number.name"
      placeholder="Jordan eller"
      append-icon="mdi-account-check"
      outlined
    />
  </div>
</template>

<script>
import ModelableMixin from '../../../../mixins/modelable';

export default {
  name: 'Number',

  mixins: [
    ModelableMixin,
  ],
};
</script>

<style scoped>

</style>
